import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { moveDeviceUrl } from "./api-url.constants";

export interface MoveDeviceParams {
  roomId: string;
  monitorId: string;
  targetRoomId: string;
}

export const moveDevice = async ({
  roomId,
  monitorId,
  targetRoomId,
}: MoveDeviceParams): Promise<void> => {
  const response = await typedFetch(moveDeviceUrl(roomId, monitorId), {
    method: API_METHODS.PUT,
    body: JSON.stringify({ targetRoomId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || "Error moving device");
  }
};
